.c-modal {
  transition: opacity 0.25s ease;
  z-index: calc(var(--z-index-top) + 1);
  display: none;
  align-items: flex-start;
  justify-content: center;
  position: fixed;
  inset: 0px;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
  --tw-bg-opacity: 0.4;
  overflow: auto;
}

  .c-modal__inner {
    transition: opacity 0.25s ease;
    max-width: 850px;
    max-height: 95%;
    position: relative;
    overflow: visible;
    padding: 0px;
    margin-top: 0.5rem;

  }

  @media (min-width: 1024px) {

  .c-modal__inner {
    margin-top: 6rem;
  }
}

  @media (max-width: 767px) {

  .c-modal__inner {
    width: 97%;
  }
}

  .c-modal__content {
  border-radius: 0.5rem;
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1rem;
}

  @media (min-width: 1024px) {

  .c-modal__content {
    padding: 1.5rem;
  }
}

  .c-modal__content {
  overflow: visible;
}

  @media (max-width: 767px) {

  .c-modal__content {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

  .c-modal__content h1 {
  margin-bottom: 1rem;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 600;
}

  @media (max-width: 767px) {

  .c-modal__content h1 {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

  .c-modal__title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -1rem;
  margin-left: -1rem;
  margin-right: -1rem;
}

  @media (min-width: 1024px) {

  .c-modal__title {
    margin-top: -1.5rem;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
}

  .c-modal__title {
  margin-bottom: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
  text-align: center;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity, 1));
  position: relative;
}

  .c-modal__actions,
  .c-modal .c-modal__content .form-actions {
  display: flex;
  width: auto;
  margin-bottom: -1rem;
  margin-left: -1rem;
  margin-right: -1rem;
}

  @media (min-width: 1024px) {

  .c-modal__actions,
  .c-modal .c-modal__content .form-actions {
    margin-bottom: -1.5rem;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
}

  .c-modal__actions,
  .c-modal .c-modal__content .form-actions {
  margin-top: 2rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1rem;
  padding-right: 1rem;
}

  @media (min-width: 1024px) {

  .c-modal__actions,
  .c-modal .c-modal__content .form-actions {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

  .c-modal__actions,
  .c-modal .c-modal__content .form-actions {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}

/*# sourceMappingURL=data:application/json;base64,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 */